import { render, staticRenderFns } from "./IntelligentBookingResultCwmi.vue?vue&type=template&id=0ca854a1&"
import script from "./IntelligentBookingResultCwmi.vue?vue&type=script&lang=js&"
export * from "./IntelligentBookingResultCwmi.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentBookingResultCwmi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca854a1')) {
      api.createRecord('0ca854a1', component.options)
    } else {
      api.reload('0ca854a1', component.options)
    }
    module.hot.accept("./IntelligentBookingResultCwmi.vue?vue&type=template&id=0ca854a1&", function () {
      api.rerender('0ca854a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResultCwmi.vue"
export default component.exports